import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { disputesApi, DISPUTE_REASONS, inputCls, btnCls } from "./shared";

export function NewDisputeForm({ reviewId, attemptNo, onDone, onCancel }) {
  const [reason, setReason] = useState(DISPUTE_REASONS[0]);
  const [text, setText] = useState("");
  const [when, setWhen] = useState("");
  const [templates, setTemplates] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { disputesApi.templates().then(setTemplates).catch(() => {}); }, []);

  const pick = (id) => { const t = templates.find(x => String(x.id) === id); if (t) { setText(t.body); if (t.reason) setReason(t.reason); } };
  const saveTpl = async () => {
    const title = window.prompt("Şablon adı:");
    if (!title || !text.trim()) return;
    try { const t = await disputesApi.addTemplate({ title, reason, body: text }); setTemplates(p => [...p, t]); toast.success("Şablon kaydedildi"); }
    catch { toast.error("Şablon kaydedilemedi"); }
  };
  const delTpl = async (id) => {
    if (!window.confirm("Şablon silinsin mi?")) return;
    await disputesApi.deleteTemplate(id); setTemplates(p => p.filter(t => t.id !== id));
  };
  const submit = async () => {
    if (!text.trim()) return toast.error("Savunma metni yazın");
    setBusy(true);
    try { await disputesApi.addDispute(reviewId, { reason, defense_text: text, submitted_at: when || null }); toast.success(`${attemptNo}. itiraz kaydedildi`); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Kaydedilemedi"); }
    setBusy(false);
  };

  return (
    <div className="space-y-2.5 p-3 rounded-lg border border-slate-700 bg-slate-800/50" data-testid="new-dispute-form">
      <div className="text-sm font-semibold text-white">{attemptNo}. itiraz</div>
      <div className="flex gap-2 flex-wrap">
        <select value={reason} onChange={e => setReason(e.target.value)} className={inputCls} data-testid="dispute-reason">
          {DISPUTE_REASONS.map(r => <option key={r}>{r}</option>)}
        </select>
        <select value="" onChange={e => pick(e.target.value)} className={inputCls} data-testid="dispute-template-pick">
          <option value="">Şablondan doldur…</option>
          {templates.map(t => <option key={t.id} value={t.id}>{t.title}</option>)}
        </select>
        <input type="datetime-local" value={when} onChange={e => setWhen(e.target.value)} className={inputCls} title="İtiraz tarihi (boşsa şimdi)" data-testid="dispute-date" />
      </div>
      <textarea value={text} onChange={e => setText(e.target.value)} rows={5} placeholder="Platforma yazdığınız savunma metni…" className={`${inputCls} w-full`} data-testid="dispute-text" />
      {templates.length > 0 && (
        <div className="flex flex-wrap gap-1.5 text-[11px]">
          {templates.map(t => <span key={t.id} className="px-2 py-0.5 rounded bg-slate-700 text-slate-300">{t.title} <button onClick={() => delTpl(t.id)} className="ml-1 text-slate-500 hover:text-rose-400" data-testid={`template-delete-${t.id}`}>×</button></span>)}
        </div>
      )}
      <div className="flex gap-2 justify-end">
        <button onClick={saveTpl} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200 py-1.5`} data-testid="dispute-save-template">Şablon olarak kaydet</button>
        <button onClick={onCancel} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200 py-1.5`} data-testid="dispute-cancel">Vazgeç</button>
        <button onClick={submit} disabled={busy} className={`${btnCls} bg-blue-600 hover:bg-blue-500 text-white py-1.5`} data-testid="dispute-submit">İtirazı kaydet</button>
      </div>
    </div>
  );
}

export function EventForm({ reviewId, onDone, onCancel }) {
  const [kind, setKind] = useState("call");
  const [channel, setChannel] = useState("Telefon");
  const [contact, setContact] = useState("");
  const [body, setBody] = useState("");
  const submit = async () => {
    if (!body.trim()) return toast.error("Not yazın");
    try { await disputesApi.addEvent(reviewId, { kind, channel: kind === "note" ? null : channel, contact: contact || null, body }); toast.success("Kaydedildi"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Kaydedilemedi"); }
  };
  return (
    <div className="space-y-2.5 p-3 rounded-lg border border-slate-700 bg-slate-800/50" data-testid="event-form">
      <div className="flex gap-2 flex-wrap">
        <select value={kind} onChange={e => setKind(e.target.value)} className={inputCls} data-testid="event-kind">
          <option value="call">Görüşme</option><option value="email">E-posta</option><option value="note">Not</option>
        </select>
        {kind !== "note" && <select value={channel} onChange={e => setChannel(e.target.value)} className={inputCls} data-testid="event-channel">
          {["Telefon", "E-posta", "Canlı destek", "Platform paneli", "WhatsApp", "Müşteri ile"].map(c => <option key={c}>{c}</option>)}
        </select>}
        {kind !== "note" && <input value={contact} onChange={e => setContact(e.target.value)} placeholder="Kiminle? (ör. TA destek - Sarah)" className={`${inputCls} flex-1 min-w-[180px]`} data-testid="event-contact" />}
      </div>
      <textarea value={body} onChange={e => setBody(e.target.value)} rows={3} placeholder="Ne konuşuldu / ne yapıldı…" className={`${inputCls} w-full`} data-testid="event-body" />
      <div className="flex gap-2 justify-end">
        <button onClick={onCancel} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200 py-1.5`}>Vazgeç</button>
        <button onClick={submit} className={`${btnCls} bg-indigo-600 hover:bg-indigo-500 text-white py-1.5`} data-testid="event-submit">Kaydet</button>
      </div>
    </div>
  );
}

export function ResponseForm({ dispute, onDone, onCancel }) {
  const [result, setResult] = useState("rejected");
  const [text, setText] = useState("");
  const submit = async () => {
    try { await disputesApi.respond(dispute.id, { result, response_text: text || null }); toast.success(result === "removed" ? "Yorum kaldırıldı olarak işaretlendi" : "Ret kaydedildi"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Kaydedilemedi"); }
  };
  return (
    <div className="space-y-2.5 p-3 rounded-lg border border-slate-700 bg-slate-800/50" data-testid="response-form">
      <div className="text-sm font-semibold text-white">{dispute.attempt_no}. itirazın platform cevabı</div>
      <div className="flex gap-2">
        {[["rejected", "Reddedildi"], ["removed", "Kaldırıldı"]].map(([k, l]) => (
          <button key={k} onClick={() => setResult(k)} data-testid={`response-${k}`}
            className={`px-3 py-1.5 rounded-lg text-sm font-semibold border ${result === k ? (k === "removed" ? "bg-emerald-600 text-white border-emerald-600" : "bg-rose-600 text-white border-rose-600") : "bg-slate-800 text-slate-300 border-slate-700"}`}>{l}</button>
        ))}
      </div>
      <textarea value={text} onChange={e => setText(e.target.value)} rows={3} placeholder="Platformun cevabı (isteğe bağlı)" className={`${inputCls} w-full`} data-testid="response-text" />
      <div className="flex gap-2 justify-end">
        <button onClick={onCancel} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200 py-1.5`}>Vazgeç</button>
        <button onClick={submit} className={`${btnCls} bg-blue-600 hover:bg-blue-500 text-white py-1.5`} data-testid="response-submit">Kaydet</button>
      </div>
    </div>
  );
}
